/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zany_Bold_Butterfly_ClimbInputs */

const fr_zany_bold_butterfly_climb = /** @type {(inputs: Zany_Bold_Butterfly_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paiement`)
};

/**

* @param {Zany_Bold_Butterfly_ClimbInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const zany_bold_butterfly_climb = /** @type {((inputs?: Zany_Bold_Butterfly_ClimbInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zany_Bold_Butterfly_ClimbInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_zany_bold_butterfly_climb(inputs)
});